import { createReducer, on } from "@ngrx/store";
import authActions from "@state/auth/actions";
import { LoadingState } from "@state/models";
import actions from "./actions";
import { ImageProfileState } from "./models";

const initialState: ImageProfileState = {
  items: [],
  state: LoadingState.init,
  error: null
};

export const imageProfileReducer = createReducer(
  initialState,
  on(actions.imageProfileLoading, (state) => ({ ...state, state: LoadingState.loading, error: null })),
  on(actions.imageProfileLoaded, (state, action) => ({ ...state, items: action.items, state: LoadingState.loaded, error: null })),
  on(actions.reset, () => ({ ...initialState })),
  on(actions.error, (state, action) => ({ ...state, state: LoadingState.error, error: action.error })),
  on(authActions.signedOut, () => ({ ...initialState }))
);
